// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import NodeCollapseOutlinedSvg from "@fishx/icons-svg/es/asn/NodeCollapseOutlined";
import FishxIcon from '../components/FishxIcon';

var NodeCollapseOutlined = function NodeCollapseOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: NodeCollapseOutlinedSvg
  }));
};

NodeCollapseOutlined.displayName = 'NodeCollapseOutlined';
export default React.forwardRef(NodeCollapseOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/NodeCollapseOutlined.js
// module id = 3163
// module chunks = 0